/**
 * 需要观察的数据
 */
const state = {
  // 菜单列表
  menuList: [],
  mobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(
    window.navigator.userAgent
  ),
  isWechat: /micromessenger/i.test(window.navigator.userAgent.toLowerCase()),
  sheetVisible: false,
  authorities: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js